export default class FloorplanFeatures {
    group = '';
    characteristics = [];

    constructor(data) {
        this.group = data?.group ?? this.group;
        this.characteristics = (data?.characteristics ?? []).map(c => ({
            feature: c?.feature ?? '',
            amenity: c?.amenity ?? null,
        }));
    }
}
